import React from 'react';
import EditorString from '../EditorString/EditorString';
import { ProductPageModel } from '../../Types/ProductPageModel';
import { translate } from '../../Services/translation';
import Placeholder from '../ProductPage/Placeholder';
import Certificates from './Certificates';

const ProductPageDescriptionTab = ({
  productPage,
}: {
  productPage: ProductPageModel;
}) => {
  const productItem = productPage.productItem;
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div>
        <h2 className="h1 mb-3">{productItem.name}</h2>
        {(productItem.itemCollection || productItem.id) && (
          <div className="pretitle-sm mb-5 flex gap-6 uppercase text-gray-500">
            {productItem.itemCollection && (
              <span>
                {translate('general.collection')}:{' '}
                {productItem.itemCollection}
              </span>
            )}
            {productItem.id && (
              <span>
                {translate('general.article-number')}: {productItem.id}
              </span>
            )}
          </div>
        )}
        {productItem.description && (
          <span>
            <EditorString
              value={productItem.description.replace(/[\n\r]/g, '<br/>')}
            />
          </span>
        )}
      </div>
      <div className="mt-4 lg:mt-0">
        <Certificates
          itemIsEasyUp={productPage.itemIsEasyUp}
          certificateList={productPage.certificates}
        />
      </div>
    </div>
  );
};

export default ProductPageDescriptionTab;
